import React, { useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { Icon } from "../../../components/Icon/Icon";
import cs from "classnames";
import hover353Image from "../../../assets/images/Infinite353/353-hover.png";
import hover50x60Image from "../../../assets/images/Infinite60x50/60x50-hover.png";
import hover110x313Image from "../../../assets/images/Infinite313x110/313x110-hover.png";

import "./OtherProducts.scss";

const OtherProducts = () => {
  const [hover353, setHover353] = useState(false);
  const [hover60, setHover60] = useState(false);
  const [hover50, setHover50] = useState(false);
  const [hover313, setHover313] = useState(false);
  const [hover110, setHover110] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { ref: product353Ref, inView: product353Visibility } = useInView();
  const { ref: product60Ref, inView: product60Visibility } = useInView();
  const { ref: product50Ref, inView: product50Visibility } = useInView();
  const { ref: product313Ref, inView: product313Visibility } = useInView();
  const { ref: product110Ref, inView: product110Visibility } = useInView();

  return (
    <div className="OtherProducts">
      <div className="OtherProducts__container">
        {location.pathname === "/infinite-353" ? (
          <></>
        ) : (
          <div
            ref={product353Ref}
            className={cs(
              "OtherProducts__product",
              product353Visibility && "OtherProducts__product-animation353",
            )}
            onClick={() => {
              navigate("/infinite-353");
            }}
            onMouseEnter={() => {
              setHover353(true);
            }}
            onMouseLeave={() => {
              setHover353(false);
            }}
          >
            <div className="OtherProducts__product-groupOne">
              <div className="OtherProducts__product-brand">Infinite</div>
              <div className="OtherProducts__product-id">353</div>
            </div>
            <div className="OtherProducts__product-groupTwo">
              <Icon
                className={cs(
                  "OtherProducts__product-image",
                  !hover353 && "OtherProducts__product-image-active",
                )}
                icon="353"
              />
              <img
                className={cs(
                  "OtherProducts__product-render",
                  hover353 && "OtherProducts__product-render-active",
                )}
                src={hover353Image}
              />
            </div>
          </div>
        )}
        {location.pathname === "/infinite-60" ? (
          <></>
        ) : (
          <div
            ref={product60Ref}
            className={cs(
              "OtherProducts__product",
              product60Visibility && "OtherProducts__product-animation60",
            )}
            onClick={() => {
              navigate("/infinite-60");
            }}
            onMouseEnter={() => {
              setHover60(true);
            }}
            onMouseLeave={() => {
              setHover60(false);
            }}
          >
            <div className="OtherProducts__product-groupOne">
              <div className="OtherProducts__product-brand">Infinite</div>
              <div className="OtherProducts__product-id">60</div>
            </div>
            <div className="OtherProducts__product-groupTwo">
              <Icon
                className={cs(
                  "OtherProducts__product-image",
                  !hover60 && "OtherProducts__product-image-active",
                )}
                icon="50-60"
              />
              <img
                className={cs(
                  "OtherProducts__product-render",
                  hover60 && "OtherProducts__product-render-active",
                )}
                src={hover50x60Image}
              />
            </div>
          </div>
        )}
        {location.pathname === "/infinite-50" ? (
          <></>
        ) : (
          <div
            ref={product50Ref}
            className={cs(
              "OtherProducts__product",
              product50Visibility && "OtherProducts__product-animation50",
            )}
            onClick={() => {
              navigate("/infinite-50");
            }}
            onMouseEnter={() => {
              setHover50(true);
            }}
            onMouseLeave={() => {
              setHover50(false);
            }}
          >
            <div className="OtherProducts__product-groupOne">
              <div className="OtherProducts__product-brand">Infinite</div>
              <div className="OtherProducts__product-id">50</div>
            </div>
            <div className="OtherProducts__product-groupTwo">
              <Icon
                className={cs(
                  "OtherProducts__product-image",
                  !hover50 && "OtherProducts__product-image-active",
                )}
                icon="50-60"
              />
              <img
                className={cs(
                  "OtherProducts__product-render",
                  hover50 && "OtherProducts__product-render-active",
                )}
                src={hover50x60Image}
              />
            </div>
          </div>
        )}
        {location.pathname === "/infinite-313" ? (
          <></>
        ) : (
          <div
            ref={product313Ref}
            className={cs(
              "OtherProducts__product",
              product313Visibility && "OtherProducts__product-animation313",
            )}
            onClick={() => {
              navigate("/infinite-313");
            }}
            onMouseEnter={() => {
              setHover313(true);
            }}
            onMouseLeave={() => {
              setHover313(false);
            }}
          >
            <div className="OtherProducts__product-groupOne">
              <div className="OtherProducts__product-brand">Infinite</div>
              <div className="OtherProducts__product-id">313</div>
            </div>
            <div
              className="OtherProducts__product-groupTwo"
              style={{ height: "fit-content" }}
            >
              <Icon
                className={cs(
                  "OtherProducts__product-image",
                  !hover313 && "OtherProducts__product-image-active",
                )}
                style={{ padding: "0 30px 0 0" }}
                icon="313-110"
              />
              <img
                style={{ padding: "0 30px 0 0" }}
                className={cs(
                  "OtherProducts__product-render",
                  hover313 && "OtherProducts__product-render-active",
                )}
                src={hover110x313Image}
              />
            </div>
          </div>
        )}
        {location.pathname === "/infinite-110" ? (
          <></>
        ) : (
          <div
            ref={product110Ref}
            className={cs(
              "OtherProducts__product",
              product110Visibility && "OtherProducts__product-animation110",
            )}
            onClick={() => {
              navigate("/infinite-110");
            }}
            onMouseEnter={() => {
              setHover110(true);
            }}
            onMouseLeave={() => {
              setHover110(false);
            }}
          >
            <div className="OtherProducts__product-groupOne">
              <div className="OtherProducts__product-brand">Infinite</div>
              <div className="OtherProducts__product-id">110</div>
            </div>
            <div
              className="OtherProducts__product-groupTwo"
              style={{ height: "fit-content" }}
            >
              <Icon
                className={cs(
                  "OtherProducts__product-image",
                  !hover110 && "OtherProducts__product-image-active",
                )}
                style={{ padding: "0 30px 0 0" }}
                icon="313-110"
              />
              <img
                style={{ padding: "0 30px 0 0" }}
                className={cs(
                  "OtherProducts__product-render",
                  hover110 && "OtherProducts__product-render-active",
                )}
                src={hover110x313Image}
              />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default OtherProducts;
